var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { catchApplyRescheduleFailAnalytics, catchApplyRescheduleSuccessAnalytics, } from '../../utils/reschedules/analytics';
import { RMS_AVAILABLE_DELIVER_SLOTS_PATH, RMS_RESCHEDULES_PATH, RMS_AVAILABLE_DELIVER_SLOTS_GUEST_PATH, RMS_RESCHEDULES_GUEST_PATH, } from '../../constants/paths';
import { getWindow, getHost } from '../../utils/general';
import { apiRMS } from '../axios-client';
/** @see {@link apiRMS} */
var baseurl = getHost();
// RMS Order Details Calls
export var GetRescheduleSlotsAPI = function (requestData, traceId) {
    return apiRMS.post(RMS_AVAILABLE_DELIVER_SLOTS_PATH, requestData, {
        headers: {
            parentTraceId: traceId,
        },
        baseURL: baseurl,
    });
};
export var GetRescheduleSlotsGuestAPI = function (requestData, token, traceId) {
    return apiRMS.post(RMS_AVAILABLE_DELIVER_SLOTS_GUEST_PATH, requestData, {
        headers: {
            'X-Auth-GuestToken': "".concat(token),
            parentTraceId: traceId,
        },
        baseURL: baseurl,
    });
};
export var ApplyReschedulesAPI = function (requestData, reschedule, isDFSRescheduleEnabled, fulfillmentType, setRescheduleError, setRescheduleLoading, setIsSurvey, isAuthTHDUser, token, traceId, daySlotsList) {
    setRescheduleLoading(true);
    var rescheduleType;
    if (fulfillmentType === 'Appliance') {
        rescheduleType = reschedule || null;
    }
    if (fulfillmentType === 'BuyOnlineDeliverFromStore') {
        rescheduleType = isDFSRescheduleEnabled || null;
    }
    var path = isAuthTHDUser
        ? RMS_RESCHEDULES_PATH
        : RMS_RESCHEDULES_GUEST_PATH;
    var config;
    if (!isAuthTHDUser && traceId) {
        config = {
            headers: {
                'X-Auth-GuestToken': "".concat(token),
                parentTraceId: traceId,
            },
        };
    }
    else if (isAuthTHDUser && traceId) {
        config = { header: { parentTraceId: traceId } };
    }
    return apiRMS
        .post(path, requestData, __assign(__assign({}, config), { baseURL: baseurl }))
        .then(function () {
        var _a, _b;
        setRescheduleLoading(false);
        catchApplyRescheduleSuccessAnalytics(fulfillmentType, daySlotsList);
        (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage) === null || _b === void 0 ? void 0 : _b.setItem('bannerState', JSON.stringify({
            state: 'success',
            reschedulable: rescheduleType,
        }));
        setIsSurvey(true);
    })
        .catch(function () {
        setRescheduleLoading(false);
        setRescheduleError(true);
        catchApplyRescheduleFailAnalytics(fulfillmentType);
    });
};
